module.exports = __webpack_public_path__ + "img/img01.b7f9546e.png";